import { styled } from '../../styles';
import { Row } from '../layout';
import theme from '../../styles/theme';
import { TOOLBAR_CONTROL_HEIGHT } from './consts';
export const milkdownStyles = {
    // this is the outermost milkdown container
    '[data-milkdown-root="true"]': {
        height: '100%',
    },
    // this is the child of  '[data-milkdown-root="true"]':
    '.milkdown': {
        fontFamily: theme.text.bodyFontFamily,
        fontSize: theme.text.size.medium,
        lineHeight: theme.text.lineHeight.medium,
        fontWeight: '400',
        color: theme.text.color.dark,
        height: '100%',
    },
    '.milkdown strong': {
        fontWeight: '600',
    },
    '.milkdown em': {
        fontStyle: 'italic',
    },
    '.milkdown h1': {
        fontFamily: theme.text.headingFontFamily,
        fontSize: theme.text.size.large,
        fontWeight: '500',
    },
    '.milkdown h2': {
        fontFamily: theme.text.headingFontFamily,
        fontSize: theme.text.size.mediumLarge,
        fontWeight: '500',
    },
    '.milkdown h3': {
        fontFamily: theme.text.headingFontFamily,
        fontSize: theme.text.size.notQuiteAllTheWayMediumLarge,
        fontWeight: '500',
    },
    '.milkdown h4': {
        fontFamily: theme.text.headingFontFamily,
        fontSize: theme.text.size.medium,
        fontWeight: '500',
    },
    /* override the default in favor of list component */
    '.milkdown ul, ol': {
        listStyle: 'none',
        paddingLeft: '0.5rem',
    },
    /* The list item itself needs flex to put label and content side-by-side */
    '.milkdown li.list-item': {
        display: 'flex',
        alignItems: 'flex-start',
        gap: '0.5rem',
        marginBottom: '0.25rem',
    },
    '.ProseMirror.focus-visible': {
        boxShadow: 'none', // remove light blue outline from focus
    },
};
export const ToolbarWrapper = styled(Row)(({ theme, padding, height }) => ({
    borderBottom: `1px solid ${theme.colors.grey10}`,
    borderTopLeftRadius: '.5rem',
    borderTopRightRadius: '.5rem',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding,
    height,
    backgroundColor: theme.colors.white,
}));
export const getFormatButtonIconFillColor = (isModeEnabled) => isModeEnabled ? theme.colors.blue50 : undefined;
export const toolbarButtonStyles = {
    height: TOOLBAR_CONTROL_HEIGHT,
    aspectRatio: 1,
    borderRadius: 0,
};
//# sourceMappingURL=styles.js.map